import {QuoteStore} from "../../../quote/store/QuoteStore";
import {EquityAccountService} from "../services/EquityAccountService";
import {EquityAccountViewStore} from "./EquityAccountViewStore";
import {SecurityInformationStore} from "../../../security/info/store/SecurityInformationStore";
import {DividendsStore} from "../../../dividends/store/DividendsStore";
import {TechnicalIndicatorsStore} from "../../../technical-indicators/store/TechnicalIndicatorsStore";
import {PriceStrategyService} from "../../../components/inputs/price/service/PriceStrategyService";
import {ClientEventService} from "../../../services/client-events/ClientEventService";
import {AveragePriceUpdateRequestService} from "../../services/AveragePriceUpdateRequestService";

export type EquityAccountViewStoreFactory = () => EquityAccountViewStore;

/** @ngInject */
export function equityAccountViewStoreFactory(equityAccountService: EquityAccountService,
                                              quoteStore: QuoteStore,
                                              securityInformationStore: SecurityInformationStore,
                                              dividendsStore: DividendsStore,
                                              technicalIndicatorsStore: TechnicalIndicatorsStore,
                                              priceStrategyService: PriceStrategyService,
                                              clientEventService: ClientEventService,
                                              averagePriceUpdateRequestService: AveragePriceUpdateRequestService): EquityAccountViewStoreFactory {
    return () => new EquityAccountViewStore(equityAccountService,
                                            quoteStore,
                                            securityInformationStore,
                                            dividendsStore,
                                            technicalIndicatorsStore,
                                            priceStrategyService,
                                            clientEventService,
                                            averagePriceUpdateRequestService);
}
